import React, {Component, Fragment} from "react";
import {Route, Switch} from "react-router-dom";
import PagePayments from "./PagePayments";
import Cashes from "../Cashes/Cashes";
import About from "../About/About";
import Betgames from "../Betgames/Betgames";

class Page extends Component {
	render() {
		return (
			<Fragment>
				{window.location.href.indexOf('betgames') !== -1 &&
					<div className="betgames">
						<div id="betgames_div_iframe" style={{width : 1000}}></div>
					</div>
				}

				<div className="page">
					<Switch>
						<Route path={'/page/payments'} component={PagePayments}/>
						<Route path={'/user/forgot'} component={PagePayments}/>
						<Route path={'/page/cashes'} component={Cashes}/>
						<Route path={'/page/about'} component={About}/>
						<Route path={'/betgames/:type?'} component={Betgames}/>
					</Switch>
				</div>
			</Fragment>
		);
	}
}

export default Page;


// WEBPACK FOOTER //
// ./src/app/pages/Page/PageContainer.js